import { Icon } from '@iconify/react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/shadcn/sheet';
import type { HostListItem } from '@/types/communityHost';
import { formatMonthYear } from './hostFormat';

interface HostActionsSheetProps {
  host: HostListItem | null;
  onClose: () => void;
  onViewProfile: (host: HostListItem) => void;
  onRemove: (host: HostListItem) => void;
}

export function HostActionsSheet({ host, onClose, onViewProfile, onRemove }: HostActionsSheetProps) {
  const showRemove = Boolean(host && host.can_remove && !host.is_self && host.kind === 'co_host');
  const sinceLabel = formatMonthYear(host?.since);

  return (
    <Sheet open={!!host} onOpenChange={(open) => { if (!open) onClose(); }}>
      <SheetContent
        side="bottom"
        showCloseButton={false}
        className="rounded-t-3xl border-t border-gray-100 px-5 pt-4 pb-8"
      >
        <div className="w-12 h-1 bg-gray-200 rounded-full mx-auto mb-4" />
        <div className="flex items-start justify-between gap-3 mb-4">
          <div className="min-w-0">
            <SheetHeader className="text-left space-y-0.5">
              <SheetTitle className="text-base font-extrabold text-[#0E1726] truncate">
                {host?.name}
              </SheetTitle>
            </SheetHeader>
            <p className="text-xs text-gray-400 font-medium mt-0.5">
              Co-host sejak {sinceLabel}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-gray-100 text-gray-500 flex items-center justify-center cursor-pointer"
            aria-label="Tutup"
          >
            <Icon icon="ph:x-bold" className="w-4 h-4" />
          </button>
        </div>

        <div className="divide-y divide-gray-100 border-t border-gray-100">
          <button
            type="button"
            onClick={() => host && onViewProfile(host)}
            className="w-full py-3.5 flex items-center gap-3.5 text-left cursor-pointer"
          >
            <div className="w-10 h-10 rounded-2xl bg-orange-50 text-[#FC480D] flex items-center justify-center">
              <Icon icon="ph:user-circle-bold" className="w-5 h-5" />
            </div>
            <span className="flex-1 text-sm font-bold text-[#0E1726]">Lihat Profile</span>
            <Icon icon="ph:caret-right-bold" className="w-4 h-4 text-gray-300" />
          </button>

          {showRemove && (
            <button
              type="button"
              onClick={() => host && onRemove(host)}
              className="w-full py-3.5 flex items-center gap-3.5 text-left cursor-pointer"
            >
              <div className="w-10 h-10 rounded-2xl bg-red-50 text-red-500 flex items-center justify-center">
                <Icon icon="ph:trash-bold" className="w-5 h-5" />
              </div>
              <span className="flex-1 text-sm font-bold text-red-500">Hapus Akses</span>
              <Icon icon="ph:caret-right-bold" className="w-4 h-4 text-red-300" />
            </button>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
